import { css } from "@emotion/react";

export const mapContainer = css`
    .map-popup-container {
        position: relative;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 16px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
        border: 1px solid #e1e5e9;
        padding: 24px;
        min-width: 260px;
        max-width: 360px;
        font-family: SCDream4;
        pointer-events: auto;
        z-index: 1000;
    }

    .map-popup-header-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        cursor: move;
    }

    .draggable-header {
        cursor: move;
    }

    .map-popup-body {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .map-popup-footer {
        margin-top: 12px;
    }

    .map-popup-header {
        margin: 0 0 20px 0;
        font-size: 20px;
        font-weight: 700;
        color: #1a1a1a;
        border-bottom: 3px solid #f0f0f0;
        padding-bottom: 8px;
        letter-spacing: -0.5px;
    }

    .map-popup-content {
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-bottom: 8px;
    }

    .map-popup-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 0;
        border-bottom: 1px solid #f5f5f5;
    }

    .map-popup-item:last-child {
        border-bottom: none;
        padding: 8px 0;
    }

    .map-popup-label {
        font-size: 14px;
        color: #666;
        font-weight: 500;
    }

    .map-popup-value {
        font-size: 15px;
        color: #1a1a1a;
        font-weight: 600;
    }

    .map-popup-buttons {
        display: flex;
        gap: 10px;
        margin-top: 20px;
    }

    .map-primary-button {
        flex: 1;
        font-family: 'SCDream4';
        padding: 10px 8px;
        border: none;
        border-radius: 10px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #002755;
        color: white;
    }

    .map-primary-button:hover {
        transform: translateY(-2px);
        background: #003366;
    }

    .map-secondary-button {
        flex: 1;
        font-family: 'SCDream4';
        padding: 10px 8px;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #f8f9fa;
        color: #495057;
    }

    .map-secondary-button:hover {
        transform: translateY(-2px);
        background: #e9ecef;
    }

    .map-close-button {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 40px;
        height: 40px;
        background: none;
        border: none;
        cursor: pointer;
        color: #888;
        transition: color 0.2s ease-in-out;
        border-radius: 50%;

        &:hover {
            color: #333;
            background-color: rgba(0, 0, 0, 0.05);
        }
    }
`;


export const mapPopupContainer = css`
    .map-popup-container {
        position: relative;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 16px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15), 0 4px 12px rgba(0, 0, 0, 0.1);
        border: 1px solid #e1e5e9;
        padding: 24px;
        min-width: 480px;
        max-width: 700px;
        font-family: SCDream4;
        pointer-events: auto;
        z-index: 999;
    }

    .map-popup-header-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        cursor: move;
    }

    .map-popup-body {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .map-popup-footer {
        margin-top: 12px;
    }

    .map-popup-header {
        margin: 0 0 20px 0;
        font-size: 20px;
        font-weight: 700;
        color: #1a1a1a;
        border-bottom: 3px solid #f0f0f0;
        padding-bottom: 8px;
        letter-spacing: -0.5px;
    }

    .map-popup-content {
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-bottom: 8px;
    }

    .map-popup-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 0;
        border-bottom: 1px solid #f5f5f5;
    }

    .map-popup-item:last-child {
        border-bottom: none;
        padding: 8px 0;
    }

    .map-popup-label {
        font-size: 14px;
        color: #666;
        font-weight: 500;
    }

    .map-popup-value {
        font-size: 15px;
        color: #1a1a1a;
        font-weight: 600;
    }

    .map-popup-buttons {
        display: flex;
        gap: 10px;
        margin-top: 20px;
    }

    .map-primary-button {
        flex: 1;
        font-family: 'SCDream4';
        padding: 10px 8px;
        border: none;
        border-radius: 10px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #002755;
        color: white;
    }

    .map-primary-button:hover {
        transform: translateY(-2px);
        background: #003366;
    }

    .map-secondary-button {
        flex: 1;
        font-family: 'SCDream4';
        padding: 10px 8px;
        border: 1px solid #dee2e6;
        border-radius: 10px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;
        background: #f8f9fa;
        color: #495057;
    }

    .map-secondary-button:hover {
        transform: translateY(-2px);
        background: #e9ecef;
    }

    .map-close-button {
        position: absolute;
        top: 15px;
        right: 15px;
        width: 40px;
        height: 40px;
        background: none;
        border: none;
        cursor: pointer;
        color: #888;
        transition: color 0.2s ease-in-out;
        border-radius: 50%;

        &:hover {
            color: #333;
            background-color: rgba(0, 0, 0, 0.05);
        }
    }
`;
